import Pickup from '@/plugins/sdk/resources/Pickup'
import { ITEM } from '@/plugins/sdk/fields'
import ScheduledPickup from '@/plugins/sdk/resources/ScheduledPickup'

export default class extends Pickup {
  static name = 'scheduledpickup_template'

  static get fields () {
    return Object.assign({}, super.fields, {
      scheduled_pickup: new ITEM(ScheduledPickup)
    })
  }
}
